export default __webpack_public_path__ + "static/media/plaque-1.01f80cd1.jpg";